import SaveIcon from "@mui/icons-material/Save";
import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButton } from "..";

export const SubmitIconButtonBase = (
  props: MuiIconButtonProps & {
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  }
) => {
  const handleClick = (e: any) => {
    if (props.onClick) {
      e.preventDefault();
      props.onClick(e);
    }
  };

  const { onClick, ...rest } = props;

  return (
    <IconButton onClick={handleClick} color="info" type="submit" size="small" {...rest}>
      <SaveIcon color="info"/>
    </IconButton>
  );
};
